export default __webpack_public_path__ + "static/media/sample_poster.981715d3.xlsx";